let translations = {}

export function loadTranslations() {
  const el = document.getElementById('forum-translations')
  if (el) {
    try { translations = JSON.parse(el.textContent) } catch { /* noop */ }
  }
}

function pluralKey(count) {
  const abs = Math.abs(count)
  if (abs === 1) return 'one'
  const mod10 = abs % 10
  const mod100 = abs % 100
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'few'
  return 'many'
}

export function t(key, params = {}) {
  const keys = key.split('.')
  let value = translations
  for (const k of keys) {
    if (value == null) return key
    value = value[k]
  }
  if (value == null) return key

  if (typeof value === 'object' && params.count != null) {
    const pKey = params.count === 0 ? 'zero' : pluralKey(params.count)
    value = value[pKey] || value['other'] || Object.values(value)[0]
  }

  if (typeof value !== 'string') return key

  return value.replace(/%\{(\w+)\}/g, (_, k) => params[k] ?? '')
}
